import { ThemeListResponse } from '@Types/mapManagement.types';
import { createAction } from '@reduxjs/toolkit';

const namespace = 'mapManagement/';

export const getThemeList = createAction(namespace + 'get_theme_list');
export const getThemeListResolved = createAction<ThemeListResponse>(
	namespace + 'get_theme_list/resolved',
);
export const getThemeListRejected = createAction(
	namespace + 'get_theme_list/rejected',
);

export const regenerateAssetTiles = createAction(
	namespace + 'regenerate_asset_tiles',
);
export const regenerateAssetTilesResolved = createAction(
	namespace + 'regenerate_asset_tiles/resolved',
);
export const regenerateAssetTilesRejected = createAction(
	namespace + 'regenerate_asset_tiles/rejected',
);

export const regenerateSensorTiles = createAction(
	namespace + 'regenerate_sensor_tiles',
);
export const regenerateSensorTilesResolved = createAction(
	namespace + 'regenerate_sensor_tiles/resolved',
);
export const regenerateSensorTilesRejected = createAction(
	namespace + 'regenerate_sensor_tiles/rejected',
);

export const regenerateInspectionTiles = createAction(
	namespace + 'regenerate_inspection_tiles',
);
export const regenerateInspectionTilesResolved = createAction(
	namespace + 'regenerate_inspection_tiles/resolved',
);
export const regenerateInspectionTilesRejected = createAction(
	namespace + 'regenerate_inspection_tiles/rejected',
);
